import React, { useState, useEffect, useMemo } from 'react';
import { Select, Checkbox, Radio, Spin, Input, Flex, Button } from 'antd';
//import debounce from 'lodash/debounce';

const { Option } = Select;

export const CostFilterSelect = ({label, fetchFunc, data, onChange, placeholder}) => {
  // 状态管理
  const [options, setOptions] = useState(data||[]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [includeExclude, setIncludeExclude] = useState('Include');
  const [loading, setLoading] = useState(false);
  //const [initialLoad, setInitialLoad] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const filteredOptions = useMemo(() => 
    options.filter(opt => 
      opt.label.toLowerCase().includes(searchText.toLowerCase())
    ), 
    [options, searchText]
  );

  const totalCount = options.length;
  const selectedCount = selectedValues.length;
  const allSelected = totalCount > 0 && selectedCount === totalCount;
  const indeterminate = !allSelected && selectedCount > 0;

  //const fetchOptions = debounce(async () => {
  const fetchOptions = async () => {
    if(fetchFunc){
      try {
        setLoading(true);
        const result = await fetchFunc();      
        setOptions(result.filter(item => item != "All").map(item => ({ 
          value: item, 
          label: item 
        })));
        //setInitialLoad(true);
      } catch (error) {
        console.error('Failed to fetch options:', error);
      } finally {
        setLoading(false);
      }
    }
  };
    //}, 300);

  const handleSelectAll = (checked) => {
    setSelectedValues(checked ? options.map(opt => opt.value) : []);
  };

  const handleOptionChange = (value, checked) => {
    setSelectedValues(prev => 
      checked ? [...prev, value] : prev.filter(v => v !== value)
    );
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const dropdownRender = menu => (
    <div style={{ padding: 8 }}>
      {/* search box */}
      <div style={{ marginBottom: 8 }}>
        <Input
          placeholder="Search..."
          allowClear
          onChange={handleSearch}
          style={{ marginBottom: 8 }}
        />
        
{/*        <Radio.Group 
          value={includeExclude}
          onChange={e => setIncludeExclude(e.target.value)}
        >
          <Radio value="Include">Includes</Radio>
          <Radio value="Exclude">Excludes</Radio>
        </Radio.Group>*/}
      </div>

      {!loading && (
      <div style={{ 
        padding: '8px 12px',
        borderBottom: '1px solid #f0f0f0',
        display: 'flex',
        alignItems: 'center'
      }}>
        <Checkbox
          checked={allSelected}
          indeterminate={indeterminate}
          onChange={e => handleSelectAll(e.target.checked)}
          style={{ marginRight: 8 }}
        />
        <span 
          onClick={() => handleSelectAll(!allSelected)}
          style={{ cursor: 'pointer' }}
        >
          Select All ({selectedCount}/{totalCount})
        </span>
      </div>)}
      {loading && <Spin size="small" style={{ display: 'block', margin: '8px auto' }} />}

      {/* option list */}
      <div style={{ maxHeight: 250, overflowY: 'auto' }}>
        {filteredOptions.map(option => (
          <div
            key={option.value}
            style={{ 
              padding: '8px 12px',
              cursor: 'pointer',
              ':hover': { backgroundColor: '#f5f5f5' }
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleOptionChange(option.value, !selectedValues.includes(option.value));
            }}
          >
            <Checkbox
              checked={selectedValues.includes(option.value)}
              style={{ pointerEvents: 'none' }}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
        {filteredOptions.length === 0 && !loading && (
          <div style={{ padding: 8, textAlign: 'center', color: '#999' }}>
            No results found
          </div>
        )}
      </div>
    </div>
  );
/*
  useEffect(() => {
    if (!loading && options.length < 1) {
      fetchOptions();
    }
  }, [loading, options]);
*/
  const handleDropdownVisibleChange = (open) => {
    if (!open){
      // trigger change event on close
      onChange?.(selectedValues, includeExclude);
    } else{
      if(options.length < 1){
        fetchOptions();
      }
    }
    setDropdownVisible(open);
  };

  return (
    <Flex gap="small" vertical>
      <div>
        <Flex style={{width: '100%'}} justify='space-between' align='center'> 
          <span>
            {label}
          </span> 
          <span>
            <Button type="link" style={{padding: 0}} onClick={() => {
              setSelectedValues([]);
              setIncludeExclude('Include');
              onChange([], includeExclude);
            }}>Clear</Button>
          </span>
        </Flex>
      </div>
      <Select
        mode="multiple"
        placeholder={placeholder||""}
        value={selectedValues}
        dropdownRender={dropdownRender}
        style={{ width: '100%' }}
        dropdownVisible={dropdownVisible}
        onDropdownVisibleChange={handleDropdownVisibleChange}
        onChange={(value) => {
          setSelectedValues(value);
          onChange?.(value, includeExclude);
        }}
      >
        {options.map(option => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    </Flex>
  );
};
